// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-3cf6cf6a] {\n  width: 90vw;\n}\n", ""]);
// Exports
module.exports = exports;
